<mat-sidenav-container>
  <mat-sidenav
    #verificationSidenav
    [mode]="'over'"
    position="end"
    [disableClose]="true"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [fixedBottomGap]="0"
    class="sign-up-sidenav">
   
    <!-- Reset Password -->
    <div *ngIf="resetStep">
      <app-reset-password></app-reset-password>
    </div>

    <!-- Verification -->
    <div *ngIf="verifyStep">
      <app-verification
        [isVerifyRoute]="isVerifyRoute"
        [inlineRegistrationCycleLogId]="inlineRegistrationCycleLogIdForVerification"
        [inlineUser]="inlineUserForVerification"
        [inlineVerifyType]="verificationData?.verifyType"
        (closeSidebar)="onCloseSidebarFromVerification()"
        (confirmAndCloseSidebar)="onCloseAndConfirmSidebarFromVerification()"
      ></app-verification>
    </div>

    <!-- Terms & Conditions / Privacy Policy -->
    <div *ngIf="termsStep">
        <app-terms-conditions (closeTerms)="onCloseTermsSidenav()"></app-terms-conditions>
    </div>
  </mat-sidenav>

  <!-- Main sign-up content -->
  <mat-sidenav-content>
    <div class="max-[991px]:flex-col flex items-start justify-start w-full min-h-screen bg-white">
        
        <!-- Right Poster Full Screen -->
        <div class="right-poster w-[562px] min-h-screen bg-[#635ca8] flex flex-col">
            <!-- Poster Logo -->
            <div class="w-[231px] h-[46px] mt-[60px] ms-[60px] mb-[60px]">
                <img
                    class="w-full h-full"
                    src="assets/img/glameraTradeMarkLogo.png"
                    alt=""
                />
            </div>

            <!-- Business Types Image -->
            <img 
                class="w-[466px]"
                [src]="dir == 'en' ? 'assets/img/signupEN.png' : 'assets/img/signupAR.png'"
                alt=""
                />

            <!-- Welcome -->
            <div class="mt-[82px] w-full flex flex-col items-center justify-center px-4 pb-10">
                <h2 class="text-white text-[32px] font-[500] mb-[18px] text-center">
                    {{ 'welocme_to_glamera' | translate }}
                </h2>

                <div class="d-flex text-center" style="white-space: pre-line;">
                    <p class="text-white text-[16px] font-[400]">
                        {{ 'ADOBT_GLAMERA' | translate }}
                    </p>
                </div>
            </div>

        </div>

        <!-- Right Poster Mobile -->
        <div class="relative block min-[991px]:hidden w-full bg-[#635ca8]">
            <!-- Header -->
            <div class="mx-[16px] my-[24px] flex items-center justify-between">
                <!-- Poster Logo -->
                <img
                    class="w-[90px] h-[17px]"
                    src="assets/img/glameraTradeMarkLogo.png"
                    alt=""
                />

                <!-- Language & Watch Video Button -->
                <app-auto-registration-top-bar
                    logoSrc="assets/img/glameraTradeMarkLogo.png"
                    [showLogo]="false"
                    [darkMode]="true"
                    languageColor="#fff"
                    (watchVideo)="onOpenVideo()"
                ></app-auto-registration-top-bar>
            </div>
            <!-- Business Types Image & Welcome -->
            <div class="flex items-center justify-between mb-[24px]">
                <!-- Business Types Image -->
                <img 
                    class="w-[174px]"
                    [src]="dir == 'en' ? 'assets/img/signupEN.png' : 'assets/img/signupAR.png'"
                    alt=""
                    />
                <!-- Welcome -->
                <div class="ms-[12px]">
                    <h2 class="text-white text-[10px] font-[500] mb-[9px] text-start">
                        {{ 'welocme_to_glamera' | translate }}
                    </h2>

                    <div class="d-flex text-start" style="white-space: pre-line;">
                        <p class="text-white text-[10px] text-start">
                            {{ 'ADOBT_GLAMERA' | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <!-- Bottom Shadow -->
            <div class="pointer-events-none absolute bottom-0 left-0 w-full h-[24px] bg-gradient-to-t from-[#00000033] to-transparent"></div>
        </div>

        <!-- Signup Part -->
        <div class="px-[16px] min-[991px]:ps-[48px] min-[991px]:pe-[60px] pt-[16px] min-[991px]:pt-[60px] flex-1">
            <!-- Language & Watch Video Button -->
            <div class="max-[991px]:hidden flex items-center justify-end mb-[32px]">
                <button class="me-[24px] w-[131px] h-[37px] rounded-[27px] flex items-center justify-center bg-[#635CA8]" 
                    type="button" 
                    (click)="onOpenVideo()">
                    <span class="text-[14px] text-white font-[700] me-[5px]">{{ 'WatchVideo' | translate }}</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="16" height="16" rx="8" fill="white"/>
                        <g clip-path="url(#clip0_13621_4345)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.34375C5.98071 4.34375 4.34375 5.98071 4.34375 8C4.34375 10.0193 5.98071 11.6562 8 11.6562C10.0193 11.6562 11.6562 10.0193 11.6562 8C11.6541 5.98159 10.0184 4.34588 8 4.34375ZM8 11.0938C6.29137 11.0938 4.90625 9.70863 4.90625 8C4.90625 6.29137 6.29137 4.90625 8 4.90625C9.70863 4.90625 11.0938 6.29137 11.0938 8C11.0918 9.70783 9.70783 11.0918 8 11.0938ZM9.28109 7.76586L7.59359 6.64086C7.50727 6.58326 7.39624 6.57789 7.30475 6.62687C7.21327 6.67585 7.15618 6.77123 7.15625 6.875V9.125C7.15618 9.22877 7.21327 9.32415 7.30475 9.37313C7.39624 9.42211 7.50727 9.41674 7.59359 9.35914L9.28109 8.23414C9.35945 8.182 9.40652 8.09412 9.40652 8C9.40652 7.90588 9.35945 7.818 9.28109 7.76586ZM7.71875 8.59941V7.40234L8.61805 8L7.71875 8.59941Z" fill="#694ED6"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_13621_4345">
                                <rect width="9" height="9" fill="white" transform="translate(3.5 3.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </button>
                <lib-language color="#000"></lib-language>
            </div>

            <!-- Form & Title & description -->
            <div class="">
                <!-- Title & description -->
                <div class="mb-[24px] min-[991px]:mb-[45px]">
                    <h1 class="mb-[8px] min-[991px]:mb-[16px] text-black text-[16px] min-[991px]:text-[32px] font-[700]">
                        {{ 'START_YOUR_BUSINESS' | translate }}
                    </h1>
                    <p class="text-[#4D5762] text-[12px] min-[991px]:text-[16px] font-[400]">
                        {{ 'SIMPLE_STEPS' | translate }}
                    </p>
                </div>
                <!-- Form Inputs-->
                <div class="min-[991px]:w-[80%] min-w-0 w-full">
                    <form class="" (submit)="onSubmit()" [formGroup]="form">
                        <!-- Full Name Field -->
                        <div class="min-[991px]:mb-[2px] flex flex-col">
                            <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                                {{ 'FULL_NAME' | translate }}
                            </mat-label>
                            <mat-form-field appearance="outline">
                                <input
                                    matInput
                                    [placeholder]="'ENTER_FULL_NAME' | translate"
                                    formControlName="FirstName"
                                    [maxLength]="50"
                                />
                                <mat-error>
                                    <app-error-form
                                    [name]="'FULL_NAME'"
                                    [control]="form.controls['FirstName']"
                                    [minLength]="2"
                                    [maxLength]="50"
                                    ></app-error-form>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Email Field -->
                        <div class="min-[991px]:mb-[2px] flex flex-col">
                            <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                                {{ 'EMAIL' | translate }}
                            </mat-label>
                            <mat-form-field appearance="outline">
                                <input
                                    type="email"
                                    matInput
                                    [placeholder]="'Enter_your_email' | translate"
                                    formControlName="Email"
                                />
                                <mat-error>
                                    <app-error-form
                                        [name]="'EMAIL'"
                                        [control]="form.controls['Email']"
                                    ></app-error-form>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Phone Number Field -->
                        <div class="min-[991px]:mb-[2px] flex flex-col">
                            <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                                {{ 'AUTH.PHONE_NUMBER' | translate }}
                            </mat-label>
                            <div class="w-full max-w-full min-w-0 flex max-[991px]:flex-col items-start justify-start gap-[8px] min-[991px]:gap-0">
                                <ng-container *ngIf="!countriesLoading; else phoneCountrySkeleton">
                                    <!-- Country Select Dropdown -->
                                    <mat-form-field class="w-full max-[991px]:w-full min-[991px]:w-[140px] min-[991px]:max-w-[140px] min-[991px]:min-w-[120px] min-[991px]:me-[16px]" appearance="outline">
                                        <mat-select formControlName="CountryId">
                                            <mat-select-trigger>
                                                <ng-container *ngIf="form.controls['CountryId'].value">
                                                    {{ getSelectedCountry()?.CallingCode }}
                                                </ng-container>
                                            </mat-select-trigger>
                                            <mat-option class="sign-up-country-menu-item" *ngFor="let country of countries" [value]="country.Id">
                                                <div class="d-flex align-items-center">
                                                    <img
                                                        style="border: 1px solid #ddd;"
                                                        [src]="country.FlagPath"
                                                        width="24px"
                                                        alt=""
                                                    />
                                                    <span class="text-[12px] min-[991px]:text-[16px] text-[#4D5762]">
                                                        {{ country.CallingCode }}
                                                    </span>
                                                </div>
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- Phone Input -->
                                    <mat-form-field class="w-full max-[991px]:w-full min-[991px]:flex-1 min-w-0" appearance="outline">
                                        <input
                                            matInput
                                            [placeholder]="'ENTER_PHONE_NUMBER' | translate"
                                            formControlName="MobileNumber"
                                            [maxLength]="12"
                                            appNumberOnly
                                        />
                                        <mat-error>
                                            <app-error-form
                                                [name]="'PHONE_NUMBER'"
                                                [control]="form.controls['MobileNumber']"
                                                [maxLength]="12"
                                                [minLength]="4"
                                            ></app-error-form>
                                        </mat-error>
                                    </mat-form-field>
                                </ng-container>

                                <!-- Skeletone -->
                                <ng-template #phoneCountrySkeleton>
                                    <div class="flex max-[991px]:flex-col items-center max-[991px]:items-stretch gap-4 w-full">
                                        <!-- Country Select Skeleton -->
                                        <div class="w-full min-[991px]:w-[110px] h-[42px] min-[991px]:h-[56px] rounded-[12px] bg-gray-200 animate-pulse"></div>
                                        <!-- Phone Input Skeleton -->
                                        <div class="flex-1 h-[42px] min-[991px]:h-[56px] rounded-[12px] bg-gray-200 animate-pulse"></div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>

                        <!-- Password Field -->
                        <div class="flex flex-col w-full min-w-0 overflow-hidden"
                            [ngClass]="{
                                'mb-[16px] min-[991px]:mb-[24px]':  !(form.controls['Password'].invalid && (form.controls['Password'].dirty || form.controls['Password'].touched))
                            }">
                            <mat-label class="text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                                {{ 'PASSWORD' | translate }}
                            </mat-label>
                            <mat-form-field class="w-full" appearance="outline"  subscriptSizing="dynamic" >
                                <input
                                    matInput
                                    [type]="hide ? 'password' : 'text'"
                                    formControlName="Password"
                                    [placeholder]="'ENTER_PASSWORD' | translate"
                                    [maxLength]="20"/>
                                <button
                                    mat-icon-button
                                    matSuffix
                                    (click)="hide = !hide"
                                    [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                                    [attr.aria-pressed]="hide"
                                    type="button">
                                    @if (hide) {
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-eye"
                                            viewBox="0 0 16 16">
                                            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"/>
                                            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"/>
                                        </svg>
                                    } @else {
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-eye-slash"
                                            viewBox="0 0 16 16">
                                            <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"/>
                                            <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"/>
                                            <path d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"/>
                                        </svg>
                                    }
                                </button>
                                <mat-error *ngIf="isPasswordInvalid">
                                    <app-error-form
                                        [name]="'PASSWORD'"
                                        [control]="form.controls['Password']"
                                        [minLength]="6"
                                    ></app-error-form>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Privacy Policy Checkbox -->
                        <div class="mb-[37px] min-[991px]:mb-[32px]">
                            <mat-checkbox
                                class="ms-[-11px]"
                                formControlName="AgreeToPrivacyPolicy"
                                color="primary">
                                <span class="text-[12px] min-[991px]:text-[16px] text-[#000] font-[400]">
                                    {{ 'AGREE_WITH' | translate }}
                                    <a class="pointer-events-auto !text-[#635CA8] no-underline cursor-pointer hover:!underline hover:!text-[#514A8A]" 
                                        (click)="onOpenPrivacy($event)">
                                        {{ 'PRIVACY_POLICY' | translate }}
                                    </a>
                                    {{ 'AND' | translate }}
                                    <a class="pointer-events-auto !text-[#635CA8] no-underline cursor-pointer hover:!underline hover:!text-[#514A8A]" 
                                        (click)="onOpenPrivacy($event)">
                                        {{ 'TERMS_CONDITIONS' | translate }}
                                    </a>
                                </span>
                            </mat-checkbox>
                        </div>

                        <!-- Submit Button -->
                        <div class="mb-[16px] min-[991px]:mb-[32px]">
                            <button
                                color="primary"
                                type="submit"
                                class="generic-submit-btn"
                                [disabled]="form.invalid || loading">
                                {{ 'SIGN_UP' | translate }}
                                <span class="btn-spinner-icon" *ngIf="loading"></span>
                            </button>
                        </div>

                        <!-- Login -->
                        <div class="text-center mb-[32px] min-[991px]:mb-0">
                            <p class="text-[12px] min-[991px]:text-[16px] font-[300] text-[#1C170D] m-0">
                                {{ 'HAVE_ACCOUNT' | translate }}
                                <a
                                    class="text-[12px] min-[991px]:text-[16px] text-[#635CA8] cursor-pointer no-underline ms-[3px] p-0 hover:underline"
                                    [href]="'https://' + appDomain + '/' + config.routes.LOGIN">
                                    {{ 'Login' | translate }}
                                </a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>